module.exports = __webpack_public_path__ + "img/pistol.1f6182ed.svg";